// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg[data-v-0ad0bf52]{background-color:#fff}.market[data-v-0ad0bf52]{margin:0 auto;width:1200px}.index_market[data-v-0ad0bf52]{padding-top:31px;padding-bottom:52px}.hot_range[data-v-0ad0bf52],.market-range[data-v-0ad0bf52]{margin-bottom:52px}.info_layout[data-v-0ad0bf52]{padding-bottom:40px}.info[data-v-0ad0bf52]{width:360px;display:inline-block;margin-bottom:77px}.info[data-v-0ad0bf52]:not(:first-child){margin-left:55px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
